export const sendFormData = (data) => {
    return fetch('http://localhost:3001/send-data', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
}